export default __webpack_public_path__ + "static/media/Tpb-Logopng.5df52627.png";